import { defineStore } from 'pinia'

/**
 * Store for Lynx REST api server status.
 */
export const StatusStore = defineStore('LynxStatus', {
  state: () => {
    return {
      status: false
    }
  },
  actions: {
    // since we rely on `this`, we cannot use an arrow function
    ServiceUp () {
      this.status = true
    },
    ServiceDown () {
      this.status = false
    }
  },
  getters: {
    ServerStatus: (state) => {
      return state.status
    }
  }
})

/**
 * Store for error.
 */
export const LastErrorStore = defineStore('LynxErrors', {
  state: () => {
    return {
      errmsg: null,
      errnotif: false
    }
  },
  actions: {
    // since we rely on `this`, we cannot use an arrow function
    NotifyError (err) {
      this.errmsg = err === '' ? null : err
      this.errnotif = !this.errnotif
    },
    ClearError () {
      this.errmsg = null
    }
  },
  getters: {
    LastError: (state) => {
      return state.errmsg
    },
    HasError: (state) => {
      return state.errmsg !== null && state.errmsg !== ''
    },
    ErrorListener: (state) => {
      return state.errnotif
    }
  }
})

/**
 * Store for Infos. Infos is a message that can be displayed during few seconds
 */
export const LastInfoStore = defineStore('LynxInfos', {
  state: () => {
    return {
      infomsg: null
    }
  },
  actions: {
    // since we rely on `this`, we cannot use an arrow function
    NotifyInfo (err) {
      this.infomsg = err === '' ? null : err
      this.zebool = !this.zebool
    },
    ClearInfo () {
      this.infomsg = null
    }
  },
  getters: {
    LastInfo: (state) => {
      return state.infomsg
    },
    HasInfo: (state) => {
      return state.infomsg !== null && state.infomsg !== ''
    },
    InfoListener: (state) => {
      return state.zebool
    }
  }
})

export const AuthStore = defineStore('LynxAuthInfos', {
  state: () => {
    return {
      infos: null
    }
  },
  actions: {
    // since we rely on `this`, we cannot use an arrow function
    SetAuthInfos (cred) {
      this.infos = cred
    },
    ClearAuthInfos () {
      this.infos = null
    }
  },
  getters: {
    AuthInfos: (state) => {
      return state.infos
    }
  }
})

export const AppEventsStore = defineStore('AppEventsStore', {
  state: () => {
    return {
      openSideMenu: false,
      openSearchMenu: false
    }
  },
  actions: {
    // since we rely on `this`, we cannot use an arrow function
    NotifyOpenMenu (cred) {
      this.openSideMenu = !this.openSideMenu
    }
  },
  getters: {
    OpenSideMenu: (state) => {
      return state.openSideMenu
    }
  }
})

export const ReferentialStore = defineStore('ReferentialStore', {
  state: () => {
    return {
      CandidateStates: [],
      Skills: [],
      OppStates: [],
      PositionTypes: [],
      CustomerStates: []
    }
  }
})
